/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsSync } from "../../funcs/connectionsSync.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SyncConnectionRequest$inboundSchema,
};

export const tool$connectionsSync: ToolDefinition<typeof args> = {
  name: "connections-sync",
  description: `Sync Connection

Schedules a connector to sync as soon as possible.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsSync(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
